import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 20 12" {...props}>
      <title>{props.title || 'Sort By'}</title>
      <g>
        <g stroke="none" strokeWidth="1" fillRule="evenodd">
          <g fillRule="nonzero">
            <polygon points="7.82608696 1.71514286 20 1.71514286 20 0 7.82608696 0" />
            <polygon points="7.82608696 6.85714286 16.5217391 6.85714286 16.5217391 5.14285714 7.82608696 5.14285714" />
            <polygon points="7.82608696 12 12.173913 12 12.173913 10.2857143 7.82608696 10.2857143" />
            <polygon points="3.47826087 0 0 3.42942857 1.22695652 4.638 2.60869565 3.28028571 2.60869565 12 4.34869565 12 4.34869565 3.28028571 5.73043478 4.638 6.9573913 3.42942857" />
          </g>
        </g>
      </g>
    </Icon>
  )
}
